export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.7.2',
    name: 'fpar',
    versionDate: '2026-05-21T16:14:19.853Z',
};
export default versions;
